module.exports = __webpack_public_path__ + "static/pomcl-102-bentley-e27da930dbd183d91e15066744576ecf.webp";